export const STEP4_SUBMIT_REQUEST = "STEP4_SUBMIT_REQUEST";
export const STEP4_SUBMIT_SUCCESS = "STEP4_SUBMIT_SUCCESS";
export const STEP4_SUBMIT_FAILED = "STEP4_SUBMIT_FAILED";

export const CLEAR_STEP4_FORM_SUCCESS = "CLEAR_STEP4_FORM_SUCCESS";
